<template>
  <div class="provide-battle-results">
    <div class="row">
      <Panel
        :variant="['transparent', 'stroked', 'stroked-gray', 'rounded']"
        class="w-100 p-4"
      >
        <Subheader
          class="text-center secondary-font"
          :size="1"
          :text="
            $$t('Game {number} of {total}', 'round-game-label', {
              number: round + 1,
              total: totalRounds,
            })
          "
        />
        <HeraDummyList
          v-if="isLoading"
          class="position-relative pre-loader"
          position="center"
        />
        <template v-if="!isLoading">
          <div class="d-flex justify-content-around ">
            <div
              class="players-battels"
              :class="
                isBattleCanceled || isBattleStarted ? 'battle-canceld-sm' : ''
              "
            >
              <PlayerCard
                :player="battle.players[myAccountNumber].profile"
                :description="scoreDescriptionText(myAccountNumber)"
                class="player-one align-items-start"
              />
              <div class="results-sm scores-nest">
                <Scores
                  v-model="resultsModel"
                  class="scores-block flex-shrink-0 secondary-font results-sm"
                  :allow-player-enter-results="!allowPlayerResults"
                  :class="{ 'flex-row-reverse': !!myAccountNumber }"
                  :separator="'-'"
                  edit-mode
                />
              </div>
              <PlayerCard
                :player="battle.players[myAccountNumber ? 0 : 1].profile"
                :description="scoreDescriptionText(myAccountNumber ? 0 : 1)"
                class="player-two align-items-end"
              />
            </div>
          </div>
          <div class="scores-smaller scores-nest">
            <Scores
              v-model="resultsModel"
              class="scores-block flex-shrink-0 secondary-font"
              :allow-player-enter-results="!allowPlayerResults"
              :class="{ 'flex-row-reverse': !!myAccountNumber }"
              :separator="'-'"
              edit-mode
            />
          </div>
          <div
            v-if="allowPlayerResults"
            class="d-flex justify-content-center mt-4"
          >
            <Subheader
              class="text-center secondary-font"
              :size="0.875"
              :text="
                `${$$t('Please provide photos as proof', 'provide-proof')} (${
                  battle.attachmentRequired ? '*' : $$t('optional', 'optional')
                })`
              "
            />
          </div>
          <div class="row justify-content-center flex-shrink-1 mb-4">
            <div class="attachments-containter">
              <FormEditable
                v-if="allowPlayerResults"
                class="contenteditable"
                has-drop
                has-tags
                has-mentions
                :disabled="!allowPlayerResults"
                :disable-autofocus="disableAutofocus"
                :grid="['Attachments']"
                :grid-models="[resultsModel.attachments]"
                @update="prepareResultsModelData"
                @submit="saveResults"
              />
            </div>
          </div>

          <!-- <HeraFormTextInput
            v-model="resultsModel.uri"
            v-validate="{ url: { ['require_protocol']: true } }"
            class="my-2"
            data-vv-name="wrong-url"
            :error="errors.first('wrong-url')"
            :data-vv-as="$$t('Provide video link', 'video-link-placeholder')"
            :placeholder="$$t('Provide video link', 'video-link-placeholder')"
            icon="link"
          /> -->
        </template>
        <div class="footer d-flex justify-content-center mt-5">
          <!-- <Btn
            v-if="!inline"
            :label="$$t('Cancel')"
            class="btn-secondary btn-sm h-mr-4"
            @click="cancel"
          /> -->
          <Btn
            :icon="'chat-plus'"
            class="btn-toggle"
            :class="{ active: comment }"
            @click="toggleComment"
          />
          <HeraFormTextInput
            v-if="comment && allowPlayerResults"
            v-model="resultsModel.text"
            class="my-2 mx-4"
            :data-vv-as="$$t('Enter Your message', 'enter-message-placeholder')"
            :placeholder="
              $$t('Enter Your message', 'enter-message-placeholder')
            "
          />
          <!-- <Icon class="icon" name="camera-color" :width="24" /> -->
          <Btn
            :label="$$t('Save results')"
            :disabled="isButtonDisabled"
            class="btn-accent btn-sm"
            @click="saveResults"
          />
        </div>
      </Panel>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import ROUTER_NAMES_ACCOUNT from '@/constants/router/account';

import FormEditable from '@/components/form/contentEditable/';
import Subheader from '@/components/atoms/Subheader.vue';
import Scores from '@/components/tournaments/Scores.vue';
import Btn from '@/components/atoms/HeraFormBtn.vue';
import Panel from '@/components/atoms/Panel';
import HeraFormTextInput from '@/components/atoms/form/HeraFormTextInput';
import HeraDummyList from '@/components/common/HeraDummyList';
import PlayerCard from './PlayerCard.vue';
// import Icon from '@/components/atoms/Icon';
import { BATTLE_STATUSES } from '@/constants/battles';
import { translate } from '@/mixins/translate';
import { prop } from '@/utils/factories';

export default {
  name: 'ProvideBattleResults',
  inject: ['$validator'],
  components: {
    Subheader,
    Scores,
    Btn,
    HeraFormTextInput,
    FormEditable,
    HeraDummyList,
    Panel,
    PlayerCard,
    // Icon,
  },
  mixins: [translate('_web_battle_results-modal')],
  props: {
    roundNumber: prop(Number, -1),
    inline: prop(Boolean, false),
    disableAutofocus: prop(Boolean, false),
    myAccountNumber: {
      type: Number,
      default: -1,
    },
  },
  data() {
    return {
      resultsModel: {},
      isLoading: true,
      round: Number(
        this.roundNumber > -1 ? this.roundNumber : this.$route.params.round
      ),
      comment: false,
    };
  },

  computed: {
    ...mapState('current', {
      battleId: 'accountId',
    }),
    ...mapState('my', { myAccountID: 'accountId' }),
    ...mapGetters({
      resultsByMatchId: 'resultsByMatchId',
      battle: 'dynamicBattleModel',
    }),
    isBattleStarted() {
      return this.battle.status === BATTLE_STATUSES.started;
    },
    isBattleCanceled() {
      return this.battle.status === BATTLE_STATUSES.cancelled;
    },
    allowPlayerResults() {
      return this.battle.allowPlayerResults;
    },
    results() {
      return this.resultsByMatchId(this.battle.id || this.battle._id) || {};
    },
    totalRounds() {
      return this.$lodash.isEmpty(this.results)
        ? 0
        : this.results.player_1_match_results.length;
    },
    isButtonDisabled() {
      return !!(
        this.isLoading ||
        !this.battle.allowPlayerResults ||
        this.errors.first('wrong-url') ||
        (this.battle.attachmentRequired &&
          !this.resultsModel.uri &&
          (!this.resultsModel.attachments ||
            !this.resultsModel.attachments.length))
      );
    },
    isBattleCompleted() {
      return this.battle.status === BATTLE_STATUSES.completed;
    },
  },
  watch: {
    results() {
      this.initResultsModel();
    },
  },
  created() {
    this.initResultsModel();
    this.isLoading = false;
    window.dataLayer.push({
      event: 'tournament battle details',
      from: this.$route.path,
      gameId: this.battle.tournament.game,
      tournamentId: this.battle.tournament._id,
      tournamentName: this.battle.tournament.title,
      squadSize: this.battle.squad,
      round: this.battle.round,
      stage: this.battle.stageId,
      userID: this.myAccountID,
      gameName: this.battle.tournament.game,
      tournamentCountry: this.battle.tournament.country,
      tournamentPool: this.battle.tournament.prize.prize_pool,
      regForm: this.battle.tournament.requiresRegistrationForm,
      tournamentPrivate:
        this.battle.tournament.registrationType === 'closed' ? 'true' : 'false',
      tournamentOrganizer: this.battle.tournament.eventOrganizerName,
    });
  },
  methods: {
    ...mapActions(['setBattleResults', 'errorNotify']),
    isWinner(score1, score2) {
      return this.isBattleCompleted && score1 > score2;
    },
    initResultsModel() {
      if (this.$lodash.isEmpty(this.results)) {
        this.resultsModel = {
          battleID: this.battleId,
        };
        return;
      }
      let currentAccountResultsModel = this.$lodash.cloneDeep(
        this.results[`player_${1 + this.battle.myIndex}_match_results`][
          this.round
        ]
      );
      this.resultsModel = {
        ...currentAccountResultsModel,
        battleID: this.battleId,
      };
    },
    saveResults() {
      this.isLoading = true;
      this.setBattleResults(this.resultsModel)
        .then(() => {
          this.$emit('change', this.resultsModel);
          this.cancel();
        })
        .then(
          window.dataLayer.push({
            event: 'tournament match play',
            from: this.$route.path,
            gameId: this.battle.tournament.game,
            tournamentId: this.battle.tournament._id,
            tournamentName: this.battle.tournament.title,
            squadSize: this.battle.squad,
            round: this.battle.round,
            stage: this.battle.stageId,
            userID: this.myAccountID,
            gameName: this.battle.tournament.game,
            tournamentCountry: this.battle.tournament.country,
            tournamentPool: this.battle.tournament.prize.prize_pool,
            regForm: this.battle.tournament.requiresRegistrationForm,
            tournamentPrivate:
              this.battle.tournament.registrationType === 'closed'
                ? 'true'
                : 'false',
            tournamentOrganizer: this.battle.tournament.eventOrganizerName,
          })
        )
        .catch(this.errorNotify)
        .finally(() => {
          this.isLoading = false;
        });
    },
    cancel() {
      if (!this.inline)
        this.$router.push({ name: ROUTER_NAMES_ACCOUNT.RESULTS });
    },
    prepareResultsModelData(data) {
      if (typeof data === 'string') {
        //this is comment
        this.resultsModel = { ...this.resultsModel, text: data };
      }
      if (Array.isArray(data)) {
        //this is attachments
        this.resultsModel = Object.assign({}, this.resultsModel, {
          attachments: data.map(item => item.fileId),
        });
      }
    },
    scoreDescriptionText(val) {
      return this.myAccountNumber === val
        ? this.$t('_web_battle-results-tab-card-you-label', 'You')
        : this.$t('_web_battle-results-tab-card-opponent-label', 'Opponent');
    },
    toggleComment() {
      this.comment = !this.comment;
    },
  },
};
</script>

<style lang="scss">
.provide-battle-results {
  //contenteditable local fixes for new UI
  .contenteditable {
    margin-top: 0.7rem;

    &:focus-within {
      box-shadow: none;
    }

    .input-group {
      background-color: transparent;
      border: 1px solid var(--ph-input-borders);
      border-radius: 10px;
      height: 90px;
      width: 92px;
      overflow: hidden;

      &:focus-within {
        border: 1px solid $ph-accent;
      }

      * {
        background-color: $ph-input-bg;
      }

      .form-control-editable,
      .placeholder {
        padding: 0.5rem;
      }

      .placeholder {
        color: $ph-secondary-text;
        font-size: $ph-body-font-size;
        z-index: 3;
      }

      > div,
      > div button {
        height: 100%;
        width: 100%;
        margin: 0 !important;
        justify-content: center;
      }
    }
  }

  .attachments-preview {
    display: flex;
    width: auto;
    margin: 0 !important;
    padding: 0 !important;

    .attachments-item-media {
      margin: 0.675rem;
      width: 92px;
      height: 90px;
      border-radius: 8px;
      overflow: hidden;

      img,
      video {
        height: 100%;
        width: 100%;
        object-fit: cover;
      }
    }
  }
  .scores-nest {
    .scores-block {
      border: none;
      font-size: 4rem;
      line-height: 4rem;

      input {
        height: 80px !important;
        width: 60px !important;
        background: var(--ph-card) !important;
        border-radius: 8px;
        font-size: 40px;
        line-height: 75px;
      }
    }
  }

  .battle-account {
    flex-basis: initial;
  }

  .footer {
    .btn {
      min-width: 9rem;

      &.btn-toggle {
        min-width: 3rem;
        padding: 0 !important;

        &.active svg {
          --fill: var(--ph-accent) !important;
        }
      }
    }
  }
}

.scores-smaller {
  display: none;
}
.battle-canceld-sm {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

@media (max-width: 767px) {
  .results-sm {
    display: none !important;
  }

  .scores-smaller {
    display: flex;
    flex-direction: row;
    justify-content: center;
  }

  .player-one {
    min-width: 110px;
    @include auto-rtl(padding, 0px);
    @include auto-rtl(min-width, unset);
  }

  .player-two {
    min-width: 110px;
    @include auto-rtl(padding, 0px);
    @include auto-rtl(min-width, unset);
  }

  .players-battels {
    min-width: 200px;
  }
  .battle-canceld-sm {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
}
</style>
